import React from "react";
import { PHASES, PHASE_LABELS, PHASE_STYLES } from "../lib/constants";

export const PhaseStepper = ({ current = "discovery", onChange = null, compact = false }) => {
  const idx = PHASES.indexOf(current);
  return (
    <div className="w-full" data-testid="phase-stepper">
      <div className={`grid ${compact ? "grid-cols-7" : "grid-cols-7"} gap-px bg-neutral-200 border border-neutral-200`}>
        {PHASES.map((p, i) => {
          const isActive = i === idx;
          const isPast = i < idx;
          const style = PHASE_STYLES[p];
          const clickable = !!onChange;
          return (
            <button
              key={p}
              data-testid={`phase-step-${p}`}
              disabled={!clickable}
              onClick={() => clickable && onChange(p)}
              className={`group relative bg-white text-left px-3 py-3 transition-colors ${clickable ? "hover:bg-neutral-50 cursor-pointer" : ""}`}
            >
              <div className="flex items-center gap-2">
                <span
                  className="inline-flex items-center justify-center w-5 h-5 text-[10px] font-mono"
                  style={{
                    background: isActive ? style.text : (isPast ? "#171717" : "#E5E5E5"),
                    color: isActive || isPast ? "#FFF" : "#737373",
                  }}
                >
                  {i + 1}
                </span>
                <span className={`text-xs font-medium ${isActive ? "text-neutral-900" : isPast ? "text-neutral-700" : "text-neutral-400"}`}>
                  {PHASE_LABELS[p]}
                </span>
              </div>
              {isActive && (
                <span className="absolute bottom-0 left-0 h-0.5 w-full" style={{ background: style.text }} />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};
